import { useQuery } from '@tanstack/react-query';

import { getOrderNotes } from '~/services/OrdersService';

import addUserData from '~/utils/addUserData';

export const orderNotesQueryKeys = {
  all: ['orderNotes'] as const,
  details: () => [...orderNotesQueryKeys.all, 'detail'] as const,
  detail: (orderId: string) => [...orderNotesQueryKeys.details(), orderId] as const,
};

export function useGetOrderNotes(orderId: string | undefined) {
  return useQuery({
    queryKey: orderNotesQueryKeys.detail(orderId!),
    queryFn: async () => {
      const orderNotes = await getOrderNotes(orderId!);
      return addUserData(orderNotes, 'fk_added_by_id');
    },
    enabled: !!orderId,
  });
}
